import { gql, TypedDocumentNode } from '@common/hooks';
import {
  FeatureFlagsQueryCgResponse,
  FeatureFlagsQueryVariables,
} from '@common/graphql/schema';

export const FEATURE_FLAGS_QUERY: TypedDocumentNode<
  FeatureFlagsQueryCgResponse,
  FeatureFlagsQueryVariables
> = gql`
  query FeatureFlags($flagNames: [String!]!) {
    featureFlags(flagNames: $flagNames)
  }
`;
